import React, {useState} from "react";
import styled from "styled-components";
import InfoIcon from "../Images/InfoIcon";
import {Popup} from "../Popup";


const InfoIconWithTooltip = ({tooltipTitle, float, display, position, top, toolTipType = "toast"}) => {
    const [isInfoOpen, setInfoOpen] = useState(false);
    const [tooltipPopUp, updateTooltipPopUp] = useState(false);
    //const tooltipRef = useRef()

    const StyledInfoIconBox = styled.div`
    position: relative;
    cursor: pointer;
    float: ${float};
    display: ${display};
    position: ${position};
    top: ${top};
    `

    const StyledInfoIconBoxOuter = styled.div`
    position: relative;
    `

    const StyledToolTipText = styled.div`
    margin-bottom: -2px;
    cursor: pointer;
    border-radius: 20px;
    position: absolute;
    max-width: 210px;
    min-width: 170px;
    left: -10px;
    background: #d5d3d3;
    padding: 6px 10px 6px 10px;
    text-align: center;
    font-size: 10px;
    display: ${isInfoOpen ? 'block' : 'none'}
`

    // const handleClick = (e) => {
    //     if (!tooltipRef.current.contains(e.target)) {
    //         if(isInfoOpen){
    //             setInfoOpen(false);
    //         }
    //     }
    // }
    // useEffect(() => {
    //     window.addEventListener('click', handleClick)
    //     return () => window.removeEventListener('click', handleClick)
    // }, [])

    return (
        <StyledInfoIconBoxOuter>
            <StyledInfoIconBox>
                {toolTipType === "popUp" ?
                    <>
                        <Popup
                            show={tooltipPopUp}
                            renderActions={
                                <button
                                    className="action-button primary-button"
                                    type="button"
                                    onClick={() => updateTooltipPopUp(false)}
                                >
                                    Close
                                </button>
                            }
                        >
                            {tooltipTitle}
                        </Popup>
                        <InfoIcon width="16px" height="16px" onClick={() => updateTooltipPopUp(true)}/>
                    </>
                    :
                    <>
                        <InfoIcon width="16px" height="16px" onClick={() => setInfoOpen(!isInfoOpen)}/>
                        {
                            <StyledToolTipText>
                                {tooltipTitle}
                            </StyledToolTipText>
                        }
                    </>
                }
            </StyledInfoIconBox>
        </StyledInfoIconBoxOuter>

    )
}

export default InfoIconWithTooltip